<template>
  <button class="button filled accent-1 download" @click.prevent="exportToPDF">
    Download PDF
  </button>
  <div class="pdf-content-wrapper">
    <div id="pdf-content" v-html="pdfContent"></div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  props: {
    allValues:     {
      type: Array
    },
    topValues: {
      type: Object
    }
  },

  data() {
    return {
      pdfContent:     "",
      topValuesArray: Object.entries(this.topValues)
    };
  },
  mounted() {
    // console.log('pdfGenerator component mounted')
    // console.log(this.topValues);
    // console.log(this.topValuesArray);
  },
  methods: {
    getValueDefinition(value) {
      for (let i = 0; i < this.allValues.length; i++) {
        if (this.allValues[i].name === value) {
          return this.allValues[i].definition_full;
        }
      }
    },
    exportToPDF() {
      this.pdfContent = "";
      this.pdfContent += "<p style='font-weight: 800; margin-bottom: 0px; padding: 0; text-align: center; font-size: 18px;'>Values Discovery - Self-Awareness Exercise</p>";

      for (let i = 0; i < this.topValuesArray.length; i++) {
        let value = this.topValuesArray[i][0];
        let definition = this.getValueDefinition(value);
        this.pdfContent += "<h6 style='margin: 0'><span style='display: inline-block; font-weight: 600; margin-bottom:8px; margin-right:8px;'>" + (i + 1) + ")</span>" + value + "</h6>";
        this.pdfContent += "<p style='margin: 0 0 8px; line-height: 1.4; font-size: 15px;'><span style=''></span>" + definition + "</p>";
      }

      this.pdfContent += "<p>&nbsp;</p>";
      this.pdfContent += "<hr style='margin: 0'>";
      this.pdfContent += "<p style='text-align: center;'>&copy; Greg Harris Coaching. www.gregharriscoaching.com</p>";
      this.pdfContent += "<hr style='margin: 0'>";
      this.pdfContent += "<p>&nbsp;</p>";


      setTimeout(function () {
        let pdfContentEl = document.getElementById("pdf-content");
        // console.log(pdfContentEl);
        html2pdf(document.getElementById("pdf-content"), {
          margin:      [.5, 1],
          autoPaging:  'text',
          filename:    "values-assessment.pdf",
          html2canvas: {
            allowTaint:      true,
            letterRendering: true,
            logging:         false,
            scale:           1,
          },
          jsPDF:       {unit: 'in', format: 'A4', orientation: 'portrait'}
        });
      }, 20);

    },
  }
}

</script>
